import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Rocket, MessageCircle, Timer } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function FinalCTA() {
  const {
    t,
    currency
  } = useLanguage();
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    // Set target date to 24 hours from now for the final CTA urgency
    const targetDate = new Date();
    targetDate.setHours(targetDate.getHours() + 24);
    const interval = setInterval(() => {
      const now = new Date();
      const difference = targetDate.getTime() - now.getTime();
      if (difference > 0) {
        setTimeLeft({
          hours: Math.floor(difference / (1000 * 60 * 60) % 24),
          minutes: Math.floor(difference / 1000 / 60 % 60),
          seconds: Math.floor(difference / 1000 % 60)
        });
      } else {
        clearInterval(interval);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  return <section id="contacto" className="py-16 md:py-24 bg-brand-bg relative overflow-hidden" data-id="element-102">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-[500px] bg-brand-purple/10 blur-[150px] rounded-full pointer-events-none" data-id="element-103"></div>

      <div className="container mx-auto px-4 md:px-6 max-w-4xl relative z-10" data-id="element-104">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-gradient-to-b from-brand-darker to-brand-bg border border-brand-cyan/30 rounded-3xl p-6 md:p-16 text-center shadow-[0_0_50px_rgba(0,212,255,0.1)]" data-id="element-105">
          <h2 className="text-2xl md:text-5xl font-bold mb-6 md:mb-8 leading-tight" data-id="element-106">
            {t('cta.title')}
          </h2>

          <div className="text-lg md:text-xl text-gray-300 mb-8 md:mb-10 space-y-2" data-id="element-107">
            <p data-id="element-108">{t('cta.text1')}</p>
            <p className="text-white font-bold" data-id="element-109">
              {t('cta.text2')} {currency}199{t('cta.text3')}
            </p>
            <p className="text-brand-cyan" data-id="element-110">{t('cta.text4')}</p>
          </div>

          <div className="inline-flex items-center gap-2 md:gap-3 bg-red-500/10 text-red-400 px-4 md:px-6 py-2 md:py-3 rounded-full font-mono font-bold text-sm md:text-lg mb-8 md:mb-10 border border-red-500/20" data-id="element-111">
            <Timer className="w-4 h-4 md:w-5 md:h-5" data-id="element-112" />
            <span data-id="element-113">
              {t('cta.countdown')} {String(timeLeft.hours).padStart(2, '0')}:
              {String(timeLeft.minutes).padStart(2, '0')}:
              {String(timeLeft.seconds).padStart(2, '0')} {t('cta.countdown2')}
            </span>
          </div>

          <div className="flex flex-col items-center gap-6" data-id="element-114">
            <a href="https://q5xkzi-4j.myshopify.com/cart/57520197402959:1?channel=buy_button" target="_blank" rel="noopener noreferrer" className="w-full max-w-md bg-brand-cta hover:bg-brand-ctaHover text-brand-darker font-bold text-base md:text-xl py-4 md:py-5 rounded-xl flex items-center justify-center gap-2 md:gap-3 transition-all duration-300 shadow-[0_0_20px_rgba(255,215,0,0.3)] hover:shadow-[0_0_30px_rgba(255,215,0,0.5)] hover:-translate-y-1" data-id="element-115">
              <Rocket className="w-5 h-5 md:w-6 md:h-6" data-id="element-116" />
              {t('cta.button')}
            </a>

            <div className="mt-4 md:mt-6 flex flex-col items-center gap-2" data-id="element-117">
              <p className="text-gray-400 text-sm md:text-base" data-id="element-118">
                {t('cta.prefer')}
              </p>
              <a href="https://wa.me/16672837159" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-brand-cyan hover:text-white transition-colors font-medium text-sm md:text-base" data-id="element-119">
                <MessageCircle className="w-4 h-4 md:w-5 md:h-5" data-id="element-120" />
                {t('cta.whatsapp')}
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}